import { useQuery } from '@tanstack/react-query';
import { useApiClients } from './useApi';
import { densifyUsage, type UsageRow } from '../utils/densify';

export function useUsage(days = 30) {
  const clients = useApiClients();
  return useQuery({
    queryKey: ['usage', days],
    queryFn: async (): Promise<UsageRow[]> => {
      const raw = await clients!.usage.getDaily(days);
      return densifyUsage(raw, days);
    },
    enabled: clients !== null,
    staleTime: 60_000,
  });
}
